import React from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

export const BorderedRow = (props: FlexProps): React.ReactElement => {
  const { children } = props;

  return (
    <Flex
      pl={7}
      pr={5}
      py={4}
      gap={3}
      borderWidth={1}
      borderTopWidth={0}
      position={'relative'}
      flexDirection={'column'}
      _first={{
        borderTopRadius: 'md',
        borderTopWidth: 1,
      }}
      _last={{
        borderBottomRadius: 'md',
      }}
      {...props}
    >
      {children}
    </Flex>
  );
};
